import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.857 35.743c-6.138 0-11.114 4.975-11.114 11.114 0 6.139 4.975 11.114 11.114 11.114 6.139 0 11.114-4.975 11.114-11.114 0-6.139-4.975-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117ZM33.746 46.857c0-.507.03-1.009.087-1.501h-11.9l.535 1.998h11.289c-.006-.165-.01-.331-.01-.496h-.001v-.001ZM36.618 38.678H21.811v.029l.527 1.969h12.959c.379-.707.822-1.376 1.32-1.998h.001ZM41.751 31.999h-19.94v.104l.508 1.894h19.967l-.535-1.998Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M35.851 53.975H16.017V25.053h18.974V10.024h12.991v23.771a13 13 0 0 1 3.996.993V6.028H32L12.022 21.957v32.014a4 4 0 0 0 4 4h23.887a13.212 13.212 0 0 1-4.058-3.996Zm-3.856-42.832v10.914H18.306l13.689-10.914Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M41.751 31.999h-19.94v.104l.508 1.894h19.967l-.535-1.998ZM48.094 49.778l-2.936.779.779 2.936 2.936-.779-.779-2.936ZM48.133 49.26l.699-8.491h-3.635l.698 8.491h2.238Z"
        }
      )
    ]
  }
);
export {
  t as AccountInDebtNegativeBalance
};
